import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import createOrganisationService from '../services/postOrganisation';
import OrganisationForm from './OrganisationForm';
import { ORGANISATION_STATES } from '../helpers/activeStates';
import { VERIFIED_STATES } from '../helpers/verifiedStates';
import typesService from '../../identitficationCodeTypes/services/typesService';

const CreateOrganisation = ({
  dispatchNewOrganisationPost,
  newOrganisationFetch,
  identificationCodeTypesFetch,
  dispatchIdentificationCodeTypesGet,
}) => {
  const createdByOrganisationId = useSelector(GetOrganisationId);

  useEffect(dispatchIdentificationCodeTypesGet, [dispatchIdentificationCodeTypesGet]);

  const identificationCodeTypes = useMemo(
    () =>
      (identificationCodeTypesFetch.value || []).map(idcodeType => ({
        key: idcodeType.tag,
        value: idcodeType.tag,
        text: idcodeType.name,
        validationPattern: idcodeType.validationPattern,
      })),
    [identificationCodeTypesFetch.value]
  );

  const initialValues = useMemo(
    () => ({
      isCustomer: true,
      countryCode: 'BE',
      activeStateId: ORGANISATION_STATES.ACTIVE,
      defaultCommunityId: '7a937e99-5a62-4fcc-865d-000000000001', // Nallian
      verifiedStateId: VERIFIED_STATES.VERIFIED,
      createdByOrganisationId,
    }),
    [createdByOrganisationId]
  );

  return (
    <OrganisationForm
      initialValues={initialValues}
      processingForm={!!newOrganisationFetch.pending}
      onSubmitForm={dispatchNewOrganisationPost}
      pageTitle="Create organisation"
      identificationCodeTypes={identificationCodeTypes}
    />
  );
};

CreateOrganisation.propTypes = {
  dispatchNewOrganisationPost: PropTypes.func.isRequired,
  newOrganisationFetch: PropTypes.object.isRequired,
  dispatchIdentificationCodeTypesGet: PropTypes.func.isRequired,
  identificationCodeTypesFetch: PropTypes.object.isRequired,
};

export default compose(typesService, createOrganisationService)(CreateOrganisation);
